import { render, staticRenderFns } from "./uf_is_prevails_mutual_invest_fund.vue?vue&type=template&id=0fd6a475&scoped=true"
import script from "./uf_is_prevails_mutual_invest_fund.vue?vue&type=script&lang=js"
export * from "./uf_is_prevails_mutual_invest_fund.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd6a475",
  null
  
)

export default component.exports